export const commonResources = {
  'common.logout': 'Cerrar sesión',
};

export type CommonResourceKey = 'common.logout';
